var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ui-loader" }, [
      _c("div", { staticClass: "spin u-stretch" }, [
        _c("span", { staticClass: "u-stretch" })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "spin u-stretch" }, [
        _c("span", { staticClass: "u-stretch" })
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }